module.exports = __webpack_public_path__ + "static/media/change-layer.57058590.gif";